// src/pages/Admin/AddProjectModal.jsx
import React, { useState } from "react";
import { X } from "lucide-react";
import API from "../../api";

const AddProjectModal = ({ isOpen, onClose, onProjectAdded }) => {
  const [formData, setFormData] = useState({
    customer_name: "",
    contact_number: "",
    project_name: "",
    project_category: "",
    project_technology: "", // ✅ Added field
    domain_name: "",
    domain_purchase_date: "",
    server_details: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await API.post("/admin/projects", formData);
      alert("✅ Project added successfully!");
      onProjectAdded();
      onClose();
      setFormData({
        customer_name: "",
        contact_number: "",
        project_name: "",
        project_category: "",
        project_technology: "", // ✅ reset field
        domain_name: "",
        domain_purchase_date: "",
        server_details: "",
      });
    } catch (err) {
      console.error(err);
      alert("❌ Failed to add project");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-lg rounded-xl shadow-lg p-6 relative">
        <button
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
          onClick={onClose}
        >
          <X size={20} />
        </button>

        <h2 className="text-lg font-semibold mb-4 text-gray-800">
          Add New Project
        </h2>

        <form onSubmit={handleSubmit} className="space-y-3">
          {/* Customer Name */}
          <input
            type="text"
            name="customer_name"
            placeholder="Customer Name"
            value={formData.customer_name}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded-lg"
            required
          />

          {/* Contact Number (max 10 digits) */}
          <input
            type="text"
            name="contact_number"
            placeholder="Contact Number"
            value={formData.contact_number}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              if (value.length <= 10) {
                setFormData({ ...formData, contact_number: value });
              }
            }}
            className="w-full border px-3 py-2 rounded-lg"
          />

          {/* Project Name */}
          <input
            type="text"
            name="project_name"
            placeholder="Project Name"
            value={formData.project_name}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded-lg"
            required
          />

          {/* Category */}
          <select
            name="project_category"
            value={formData.project_category}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded-lg"
            required
          >
            <option value="">Select Category</option>
            <option value="Website">Website</option>
            <option value="E-Commerce">E-Commerce</option>
            <option value="Portfolio">Portfolio</option>
            <option value="Landing Page">Landing Page</option>
            <option value="Mobile App">Mobile App</option>
            <option value="Web App">Web App</option>
            <option value="Software">Software</option>
            <option value="ERP">ERP</option>
            <option value="CRM">CRM</option>
            <option value="Inventory Management">Inventory Management</option>
            <option value="Billing System">Billing System</option>
            <option value="POS System">POS System</option>
            <option value="MLM">MLM</option>
            <option value="Corporate">Corporate</option>
            <option value="Startup">Startup</option>
            <option value="Agency">Agency</option>
            <option value="Consulting">Consulting</option>
            <option value="NGO">NGO</option>
            <option value="Educational">Educational</option>
            <option value="Hospital">Hospital</option>
            <option value="Real Estate">Real Estate</option>
            <option value="Travel">Travel</option>
            <option value="Event Management">Event Management</option>
            <option value="Government">Government</option>
            <option value="Finance">Finance</option>
            <option value="Banking">Banking</option>
            <option value="Hosting">Hosting</option>
            <option value="Domain Management">Domain Management</option>
            <option value="Server Maintenance">Server Maintenance</option>
            <option value="SEO">SEO</option>
            <option value="Digital Marketing">Digital Marketing</option>
            <option value="Retail">Retail</option>
            <option value="Wholesale">Wholesale</option>
            <option value="Manufacturing">Manufacturing</option>
            <option value="Logistics">Logistics</option>
            <option value="Construction">Construction</option>
            <option value="News Portal">News Portal</option>
            <option value="Blog">Blog</option>
            <option value="Entertainment">Entertainment</option>
            <option value="Food Delivery">Food Delivery</option>
            <option value="Healthcare">Healthcare</option>
            <option value="Fitness">Fitness</option>
            <option value="Other">Other</option>
          </select>

          {/* Project Technology ✅ */}
          <input
            type="text"
            name="project_technology"
            placeholder="Project Technology (e.g., React, Laravel, Node.js)"
            value={formData.project_technology}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded-lg"
          />

          {/* Domain */}
          <input
            type="text"
            name="domain_name"
            placeholder="Domain Name"
            value={formData.domain_name}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded-lg"
          />

          {/* Purchase Date */}
          <input
            type="date"
            name="domain_purchase_date"
            value={formData.domain_purchase_date}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded-lg"
          />

          {/* Server Details */}
          <input
            type="text"
            name="server_details"
            placeholder="Server Details"
            value={formData.server_details}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded-lg"
          />

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 disabled:opacity-50"
          >
            {loading ? "Adding..." : "Add Project"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddProjectModal;
